import { OptimizePlanSignalRMessage } from "./optimize-plan-signalR-message";

export class OptimizePlanSignalRResult {
    connectionId!: string;
    message!: OptimizePlanSignalRMessage;
}